import { ReactComponent as BackIcon } from '@paradigm/icons/src/mailru/navigation/arrow_previous_big.svg';
import { ReactComponent as MoreIcon } from '@paradigm/icons/src/mailru/navigation/more_vertical.svg';
import classNames from 'clsx';
import { ReactComponent as ShapeIcon } from 'img/icons/shape.svg';
import React, { memo, ReactElement, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { getFacesFileId } from 'reactApp/modules/faces/faces.helpers';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { renderFilterFacesModal } from 'reactApp/ui/Mobile/FilterFacesModal/FilterFacesModal.helpers';
import { ProtectedTooltip } from 'reactApp/ui/Mobile/ProtectedTooltip/ProtectedTooltip';
import { ETooltipTheme } from 'reactApp/ui/Mobile/ProtectedTooltip/ProtectedTooltip.types';

import { FacesTooltip } from './FacesTooltip/FacesTooltip';
import styles from './ViewerToolbar.css';

interface IViewerToolbarProps {
    onClose: (place) => void;
    ext: string;
    subTitle: string;
    nameWithoutExt: string;
    itemId?: string;
    faces?: string[];
    onClickOption: () => void;
    noReturn?: boolean;
}

export const ViewerToolbar = memo<IViewerToolbarProps>(
    ({ onClose, subTitle, ext, nameWithoutExt, itemId = '', faces = [], onClickOption, noReturn = false }): ReactElement => {
        const counterText = faces && faces.length <= 9 ? faces.length : '9+';
        const facesButtonsRef = useRef<HTMLDivElement | null>(null);
        const storage = useSelector(getCurrentStorage);

        const handleClose = useCallback(() => {
            onClose('click');
        }, [onClose]);

        const openFacesModal = useCallback(() => {
            const fileId = getFacesFileId(itemId);
            renderFilterFacesModal({ fileId });
        }, [itemId]);

        return (
            <div className={styles.root}>
                <div className={styles.leftGroup}>
                    {!noReturn && (
                        <div className={classNames(styles.button, styles.button_back)} onClick={handleClose} data-qa-button={'back'}>
                            <BackIcon width={16} height={20} fill="currentColor" />
                        </div>
                    )}
                    <div className={styles.info}>
                        <div className={styles.nameBlock}>
                            <div className={styles.name}>{nameWithoutExt}</div>
                            <div>.{ext}</div>
                            {storage === EStorageType.attaches && (
                                <ProtectedTooltip theme={ETooltipTheme.dark} text="Файл проверен антивирусом Касперского" />
                            )}
                        </div>
                        <div className={styles.count}>{subTitle}</div>
                    </div>
                </div>
                <div className={styles.buttons} ref={facesButtonsRef}>
                    {Boolean(faces.length) && (
                        <>
                            <div
                                className={classNames(styles.button, styles.buttonFaces)}
                                onClick={openFacesModal}
                                data-qa-button={'faces'}
                            >
                                <ShapeIcon width={20} height={20} />
                                <div className={styles.facesCount}>{counterText}</div>
                            </div>
                            <FacesTooltip onApply={openFacesModal} targetRef={facesButtonsRef} />
                        </>
                    )}
                    <div className={styles.button} onClick={onClickOption} data-qa-button={'options'}>
                        <MoreIcon width={20} height={20} fill="currentColor" />
                    </div>
                </div>
            </div>
        );
    }
);

ViewerToolbar.displayName = 'ViewerToolbar';
